// extracted by mini-css-extract-plugin
export default {"statContainer":"StatCard_statContainer__V41q2","title":"StatCard_title__e1cDz","stat":"StatCard_stat__jTW2V","tag":"StatCard_tag__ZENyb"};